export var ConditionTypeEnum;
(function (ConditionTypeEnum) {
    ConditionTypeEnum[ConditionTypeEnum["STANDARD"] = 1] = "STANDARD";
    ConditionTypeEnum[ConditionTypeEnum["SPECIAL"] = 2] = "SPECIAL";
})(ConditionTypeEnum || (ConditionTypeEnum = {}));
export var ConditionIdEnum;
(function (ConditionIdEnum) {
    ConditionIdEnum[ConditionIdEnum["BLINDED"] = 1] = "BLINDED";
    ConditionIdEnum[ConditionIdEnum["CHARMED"] = 2] = "CHARMED";
    ConditionIdEnum[ConditionIdEnum["DEAFENED"] = 3] = "DEAFENED";
    ConditionIdEnum[ConditionIdEnum["EXHAUSTION"] = 4] = "EXHAUSTION";
    ConditionIdEnum[ConditionIdEnum["FRIGHTENED"] = 5] = "FRIGHTENED";
    ConditionIdEnum[ConditionIdEnum["GRAPPLED"] = 6] = "GRAPPLED";
    ConditionIdEnum[ConditionIdEnum["INCAPACITATED"] = 7] = "INCAPACITATED";
    ConditionIdEnum[ConditionIdEnum["INVISIBLE"] = 8] = "INVISIBLE";
    ConditionIdEnum[ConditionIdEnum["PARALYZED"] = 9] = "PARALYZED";
    ConditionIdEnum[ConditionIdEnum["PETRIFIED"] = 10] = "PETRIFIED";
    ConditionIdEnum[ConditionIdEnum["POISONED"] = 11] = "POISONED";
    ConditionIdEnum[ConditionIdEnum["PRONE"] = 12] = "PRONE";
    ConditionIdEnum[ConditionIdEnum["RESTRAINED"] = 13] = "RESTRAINED";
    ConditionIdEnum[ConditionIdEnum["STUNNED"] = 14] = "STUNNED";
    ConditionIdEnum[ConditionIdEnum["UNCONSCIOUS"] = 15] = "UNCONSCIOUS";
})(ConditionIdEnum || (ConditionIdEnum = {}));
